import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';

import { WalletSummaryResponse } from '../../responses/platform/wallet-summary.response';
import { WalletWithdrawalListResponse } from '../../responses/platform/wallet-withdrawal-list.response';
import { WalletSalesListResponse } from '../../responses/platform/wallet-sales-list.response';
import { WalletWithdrawalRequest } from '../../requests/platform/wallet-withdrawal.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root'
})
export class WalletService extends CommonService {
    constructor(private http: HttpClient) {
        super();
    }

    /** Cards superiores: total, disponível, etc. */
    getSummary(): Observable<WalletSummaryResponse> {
        return this.http
            .get<WalletSummaryResponse>(
                environment.urlApiPlatform + 'Wallet/summary',
                this.addHeaderToken()
            )
            .pipe(catchError(this.handleError));
    }

    /** Solicitações em trânsito (Requested/Processing) */
    getWithdrawalsInTransit(): Observable<WalletWithdrawalListResponse> {
        return this.http
            .get<WalletWithdrawalListResponse>(
                environment.urlApiPlatform + 'Wallet/withdrawals/in-transit',
                this.addHeaderToken()
            )
            .pipe(catchError(this.handleError));
    }

    /** Histórico de retiradas (padrão: 50 linhas) */
    getWithdrawalsHistory(max: number = 50): Observable<WalletWithdrawalListResponse> {
        const params = new HttpParams().set('max', String(max));
        return this.http
            .get<WalletWithdrawalListResponse>(
                environment.urlApiPlatform + 'Wallet/withdrawals/history',
                { ...this.addHeaderToken(), params }
            )
            .pipe(catchError(this.handleError));
    }

    /** Histórico de vendas: valor bruto da venda, líquido recebido e data prevista de disponibilidade */
    getSalesHistory(max: number = 50): Observable<WalletSalesListResponse> {
        const params = new HttpParams().set('max', String(max));
        return this.http
            .get<WalletSalesListResponse>(
                environment.urlApiPlatform + 'Wallet/sales/history',
                { ...this.addHeaderToken(), params }
            )
            .pipe(catchError(this.handleError));
    }

    requestWithdrawal(req: WalletWithdrawalRequest) {
        return this.http
            .post<ReturnStruct>(
                environment.urlApiPlatform + 'Wallet/withdrawals/request',
                req,
                this.addHeaderToken()
            )
            .pipe(catchError(this.handleError));
    }
}
